import React, { useEffect, useState } from "react";

export default function PreviewPage({
    imageFile,
    onRetake,
    onContinue,
}) {
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (!imageFile) {
            setPreviewUrl(null);
            return;
        }
        const url =
            URL.createObjectURL(
                imageFile
            );
        setPreviewUrl(url);
        return () => {
            URL.revokeObjectURL(
                url
            );
        };
    }, [imageFile]);

    return (
        <div className="hv-page">
            <div className="hv-welcome-icon">
                🔍
            </div>
            <h2 className="hv-page-title">
                Review Image
            </h2>
            <p className="hv-page-description">

                Make sure your collectible is visible
                before scanning.
            </p>

            {
                previewUrl && (
                    <div className="hv-image-preview">
                        <img
                            src={previewUrl}
                            alt="Selected collectible"
                        />
                    </div>
                )
            }

            <div className="hv-button-row">
                <button
                    className="hv-secondary-button"
                    onClick={onRetake}
                >
                    Retake
                </button>
                <button
                    className="hv-primary-button"
                    onClick={onContinue}
                >
                    Scan Collectible
                </button>
            </div>
        </div>
    );
}